<template>
  <table
    v-if="!statsData.variables.condition"
    :style="cssVars"
    :class="style.borders ? 'bordered' : ''"
    class="styled-table">
    <template>
      <tr class="border-top">
        <td class="categ-title extra-pad"></td>
        <td class="categ-title" style="text-align: center !important;" >
          Total
        </td>
      </tr>
      <tr v-for="(log, index) in tableValues" :key="index">
        <td class="subcateg-title pl-4">
          <span>{{log.name}}</span>
        </td>
        <td>{{log.count}}</td>
      </tr>
    </template>
    <tr>
      <td>Total</td>
      <td>{{inpatientTotal}}</td>
    </tr>
  </table>
  <table
    v-else
    :style="cssVars"
    :class="style.borders ? 'bordered' : ''"
    class="styled-table">
    <tr class="border-top">
      <td class="categ-title extra-pad">{{conditionTitle}}</td>
      <td class="categ-title" style="text-align: center !important;" >
        Total
      </td>
    </tr>
    <template v-for="(component, index) in conditionValues">
      <tr  :key="index">
        <td class="subcateg-title pl-3">
          <span>{{component.name}}</span>
        </td>
        <td></td>
      </tr>
      <template v-for="option in component.options">
        <tr  :key="option.id">
          <td class="pl-4">
            <span>{{option.text}}</span>
          </td>
          <td>{{option.count}}</td>
        </tr>
      </template>
    </template>
    <tr>
      <td><b>Total de {{conditionTitle}}</b></td>
      <td>{{logTypeTotal}}</td>
    </tr>
  </table>
</template>

<script>
import { Component, LogbookComponentConditions } from '../../../models/Specialty'
export default {
  props: {
    logs: { type: Array },
    statsData: { type: Object }
  },
  data() {
    return {
      inpatientTotal: 0,
      logTypeTotal: 0,
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
    }
  },
  computed: {
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    },
    labeledLogs() {
      return this.$store.getters.labeledLogs.filter(log => log.logbook === this.statsData.logbookType)
    },
    tableValues() {
      let items = {}
      const logID = this.statsData.variables.row1.id
      this.labeledLogs.map(log => {
        if(log[logID]) {
          const id = log[logID].id
          if(!items[id]) {
            const count = 1
            items[id] = {
                name: log[logID].text,
                count: count,
              }
          } else if (items[id]) {
            items[id].count = items[id].count + 1
          }
        } 
      })
      Object.keys(items).map(item => {
        this.inpatientTotal = this.inpatientTotal + items[item].count
      })
      return items
    },
    conditionTitle() {
      const options = this.statsData.variables.row1.options
      const title = options.filter(option => option.value === this.statsData.variables.condition)
      return title[0].text
    },
    components() {
      return Component.query()
        .withAllRecursive()
        .get()
        .filter(component =>
          component.logbooks.includes(this.statsData.logbookType)
        )
    },
    conditionValues() {
      const conditions = LogbookComponentConditions.query()
        .get().filter(component => component['conditionalComponentOptionsIds'].includes(this.statsData.variables.condition))
      const componentIds = []
      conditions.map(cond => componentIds.push(cond.componentId))
      const componentTree = this.components.filter(component => componentIds.includes(component.id))
      const logTypeID = this.statsData.variables.row1.id
      const items = {}
      this.labeledLogs.forEach(log => {
        if(log[logTypeID].id === this.statsData.variables.condition) {
          this.logTypeTotal++
          componentTree.forEach(component => {
            const id = component.id
            if(log[id]) {
              if(!items[id]) {
                const count = 1
                const options = (component.options && component.options.length > 0) ?
                  JSON.parse(JSON.stringify(component.options)) :
                  this.createOption(log[id])
                items[id] = {
                    name: component.label,
                    options: options,
                    count: count,
                  }
              } else if (items[id]) {
                items[id].count = items[id].count + 1
              }
              if(items[id].options && items[id].options.length > 0) {
                const ids = Array.isArray(log[id].id) ? log[id].id : [log[id].id ? log[id].id : log[id].text]
                ids.forEach(item => {
                  const optionIndex = items[id].options.findIndex(option => item === option.value)
                  if(optionIndex !== -1) {
                    items[id].options[optionIndex].count ?
                      items[id].options[optionIndex].count++ :
                      items[id].options[optionIndex].count = 1
                  }
                })
              }
            }
          })
        } 
      })
      const itemKeys = Object.keys(items) 
      itemKeys.map(item => {
        items[item].options = items[item].options.filter(i => i.count)
      })
      return items
    }
  },
  methods: {
    createOption(logOption) {
      const options = []
      if(logOption.id && Array.isArray(logOption.id)) {
        logOption.id.forEach((option, index) => {
          options.push({
            value: option,
            text: logOption.text.split(',')[index]
          })
        })
      } else {
        options.push({
          value: logOption.text,
          text: logOption.text
        })
      }
      return options
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  },
  watch: {
    statsData: {
      deep: true,
      handler() {
        this.logTypeTotal = 0
      }
    }
  }
}
</script>

<style>

</style>